export const calculatePositions = (
  startHandlerPosition: number,
  endHandlerPosition: number,
  startWidth: number,
  endWidth: number,
  barWidth: number,
  gap: number
) => {
  const startPosition = startHandlerPosition - startWidth / 2;
  const endPosition = endHandlerPosition - endWidth / 2;

  const startMinX = 0;
  const startMaxX = barWidth - endWidth - startWidth - gap;
  const endMinX = startWidth + gap;
  const endMaxX = barWidth - endWidth;

  const diff = endHandlerPosition - startHandlerPosition;
  const critical = gap + startWidth / 2 + endWidth / 2;

  const offset = (critical - diff) / critical;

  const needsOffset = diff < critical;

  const startOffset = needsOffset ? (offset * (startWidth + gap)) / 2 : 0;
  const endOffset = needsOffset ? (offset * (endWidth + gap)) / 2 : 0;

  const newStartPosition = Math.max(
    startMinX,
    Math.min(startPosition - startOffset, startMaxX)
  );

  const newEndPosition = Math.max(
    endMinX,
    Math.min(endPosition + endOffset, endMaxX)
  );

  return [newStartPosition, newEndPosition];
};
